// extracted by mini-css-extract-plugin
export var headerCell = "_w-1";
export var loadingSpinnerContainer = "_w-4";
export var rowWrapper = "_w-3";
export var standaloneTable = "_w-5";
export var table = "_w-0";
export var white = "_w-2";